// extracted by mini-css-extract-plugin
export default {"pricesContainer":"ProductPrice_pricesContainer__TSuoJ","loadingProductPriceContainer":"ProductPrice_loadingProductPriceContainer__BVKCi"};